import * as React from "react";
import { Typeahead } from "react-bootstrap-typeahead";

import { FormItemVertical } from "../../../../Forms/FormItemVertical";
import { Timezone } from "../../../../../../rest/Misc/timezones";
import { ActionType } from "../flux";
import { Polyglot } from "../../../../../../polyglot";
import { TypeaheadEnterEscWrapper } from "../../../../TypeaheadEnterEscWrapper";

interface Props
{
    polyglot: Polyglot;
    options: Timezone[];
    selectedTimezone: Timezone;
    onChange: (tz: Timezone) => void;
}

export class TimezoneGroupAction extends React.Component<Props, any>
{
    static defaultProps = {
        type: ActionType.SetTimezone
    };
    
    render()
    {
        const { polyglot, options, selectedTimezone, onChange } = this.props;
        const selected = selectedTimezone ? [selectedTimezone] : [];
        
        return (
            <FormItemVertical title={polyglot.t('vehicle.label_timezone') + ':'}>
                <TypeaheadEnterEscWrapper>
                    <Typeahead key="timezones"
                        labelKey={(tz: Timezone) => tz.Display}
                        options={options}
                        selected={selected}
                        onChange={(tz: Timezone[]) => onChange((Array.isArray(tz) && tz.length > 0) ? tz[0] : null)}
                        placeholder={polyglot.t('vehicle.placeholder_timezone')} />
                </TypeaheadEnterEscWrapper>
            </FormItemVertical>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/BatchEdit/GroupActions/TimezoneGroupAction.tsx